<template>
  <div
    :class="{
      'wrapper-icon': true,
      'wrapper-icon_disabled': disabled,
      'wrapper-icon_pulsed': pulsed,
      'red': red,
    }"
    @click="$emit('clickIcon')"
  >
    <!-- plus icon -->
    <svg v-if="typeImg == 'plus'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 11.4286H11.4286V20H8.57143V11.4286H0V8.57143H8.57143V0H11.4286V8.57143H20V11.4286Z" fill="#FFFFFF"/>
    </svg>

    <!-- copy icon -->
    <svg v-if="typeImg == 'copy'" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.8 17C14.9201 17 15.4802 17 15.908 16.782C16.2843 16.5903 16.5903 16.2843 16.782 15.908C17 15.4802 17 14.9201 17 13.8V4.2C17 3.0799 17 2.51984 16.782 2.09202C16.5903 1.71569 16.2843 1.40973 15.908 1.21799C15.4802 1 14.9201 1 13.8 1H8.2C7.0799 1 6.51984 1 6.09202 1.21799C5.71569 1.40973 5.40973 1.71569 5.21799 2.09202C5 2.51984 5 3.07989 5 4.2M4.2 21H9.8C10.9201 21 11.4802 21 11.908 20.782C12.2843 20.5903 12.5903 20.2843 12.782 19.908C13 19.4802 13 18.9201 13 17.8V8.2C13 7.07989 13 6.51984 12.782 6.09202C12.5903 5.71569 12.2843 5.40973 11.908 5.21799C11.4802 5 10.9201 5 9.8 5H4.2C3.0799 5 2.51984 5 2.09202 5.21799C1.71569 5.40973 1.40973 5.71569 1.21799 6.09202C1 6.51984 1 7.07989 1 8.2V17.8C1 18.9201 1 19.4802 1.21799 19.908C1.40973 20.2843 1.71569 20.5903 2.09202 20.782C2.51984 21 3.07989 21 4.2 21Z" stroke="white" stroke-width="2"/>
    </svg>

    <!-- trash icon -->
    <!-- <svg v-if="typeImg == 'trash'" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.625 0V1.11111H0V3.33333H1.125V17.7778C1.125 18.3671 1.36205 18.9324 1.78401 19.3491C2.20597 19.7659 2.77826 20 3.375 20H14.625C15.2217 20 15.794 19.7659 16.216 19.3491C16.6379 18.9324 16.875 18.3671 16.875 17.7778V3.33333H18V1.11111H12.375V0H5.625ZM5.625 5.55556H7.875V15.5556H5.625V5.55556ZM10.125 5.55556H12.375V15.5556H10.125V5.55556Z" fill="black" fill-opacity="0.54"/>
    </svg> -->
    <svg v-if="typeImg == 'trash'" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8925 17.0357L16.8925 17.0446L15.8925 17.0357ZM1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6V5V4ZM17 6C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4V5V6ZM8 9C8 8.44772 7.55228 8 7 8C6.44772 8 6 8.44772 6 9H7H8ZM6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17H7H6ZM12 9C12 8.44772 11.5523 8 11 8C10.4477 8 10 8.44772 10 9H11H12ZM10 17C10 17.5523 10.4477 18 11 18C11.5523 18 12 17.5523 12 17H11H10ZM16 5L15 4.99107L14.8926 17.0268L15.8925 17.0357L16.8925 17.0446L17 5.00893L16 5ZM11.8927 21V20H6V21V22H11.8927V21ZM2 5H1V17H2H3V5H2ZM1 5V6H2V5V4H1V5ZM2 5V6H5V5V4H2V5ZM5 5V6H13V5V4H5V5ZM13 5V6H16V5V4H13V5ZM16 5V6H17V5V4H16V5ZM5 4.55556H6C6 3.25163 7.22916 2 9 2V1V0C6.35256 0 4 1.93212 4 4.55556H5ZM9 1V2C10.7708 2 12 3.25163 12 4.55556H13H14C14 1.93212 11.6474 0 9 0V1ZM5 4.55556H4V5H5H6V4.55556H5ZM13 4.55556H12V5H13H14V4.55556H13ZM6 21V20C4.34314 20 3 18.6569 3 17H2H1C1 19.7614 3.23857 22 6 22V21ZM15.8925 17.0357L14.8926 17.0268C14.8779 18.6731 13.5391 20 11.8927 20V21V22C14.6367 22 16.868 19.7885 16.8925 17.0446L15.8925 17.0357ZM7 9H6V17H7H8V9H7ZM11 9H10V17H11H12V9H11Z" fill="white"/>
    </svg>

    <!-- trashProducts icon -->
    <svg v-if="typeImg == 'trashProducts'" width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3652_8872)">
      <path d="M1.12868 5.23723C0.505505 5.23723 0 4.76145 0 4.17491C0 3.58838 0.505505 3.1126 1.12868 3.1126H3.89542L4.61142 0.771649C4.7523 0.304708 5.20476 0.000519979 5.69646 0.00103996L14.0204 0C14.532 0 14.964 0.320827 15.1027 0.76021L16.0756 3.1126H18.8705C19.4937 3.1126 19.9992 3.58838 19.9992 4.17491C19.9992 4.76145 19.4937 5.23723 18.8705 5.23723H1.12868ZM6.24284 3.1126H13.6608L13.2525 2.12464H6.54504L6.24284 3.1126ZM3.60096 8.23231L5.61911 23.8754H14.1475L16.3833 8.23231H3.60096ZM3.50041 25.062L1.21487 7.34783C1.20492 7.29011 1.19885 7.23083 1.19885 7.16999C1.19885 6.58346 1.7049 6.10768 2.32808 6.10768H17.6711L17.8208 6.12016C18.4368 6.19763 18.8689 6.73113 18.7865 7.31091L16.2579 25.0001C16.2237 25.5575 15.7325 26 15.1314 26H4.62026C4.05619 25.9995 3.56837 25.6022 3.50041 25.062Z" fill="#848484"/>
      </g>
      <defs>
      <clipPath id="clip0_3652_8872">
      <rect width="20" height="26" fill="white"/>
      </clipPath>
      </defs>
    </svg>

    <!-- edit icon -->
    <!-- <svg v-if="typeImg == 'edit'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 15.8339V20H4.16609L16.4533 7.71282L12.2872 3.54673L0 15.8339ZM19.675 4.49104C20.1083 4.05777 20.1083 3.35787 19.675 2.92459L17.0754 0.324955C16.6421 -0.108318 15.9422 -0.108318 15.509 0.324955L13.4759 2.35801L17.642 6.52409L19.675 4.49104Z" fill="#848484"/> -->
    <!-- </svg> -->
    <svg v-if="typeImg == 'edit'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5158 0.277668C11.2631 -0.0926559 12.1414 -0.092456 12.8888 0.277668C13.3094 0.486086 13.6735 0.865068 14.1544 1.34603C14.6354 1.82698 15.0143 2.19115 15.2228 2.61165C15.5931 3.35903 15.5931 4.23732 15.2228 4.9847C15.0664 5.3002 14.8146 5.58442 14.4953 5.9095L6.98062 13.4242C6.80342 13.6014 6.66603 13.7414 6.50796 13.8607C6.37609 13.9601 6.235 14.047 6.08706 14.1204C5.90971 14.2085 5.72327 14.2687 5.4855 14.348L3.32632 15.0677C2.87111 15.2194 2.48018 15.3511 2.16519 15.4251C1.86135 15.4965 1.48572 15.5529 1.11636 15.4212C0.632815 15.2487 0.251702 14.8677 0.0792525 14.3841C-0.0522472 14.0148 0.00397268 13.639 0.0753462 13.3353C0.149384 13.0203 0.281069 12.6292 0.432768 12.1742L1.15249 10.015C1.23171 9.77734 1.29202 9.5907 1.38003 9.41341C1.45346 9.26556 1.5404 9.12431 1.6398 8.99251C1.75903 8.83449 1.89916 8.69701 2.07632 8.51986L9.25015 1.34603C9.73114 0.86504 10.0952 0.486143 10.5158 0.277668ZM3.13687 9.5804C2.93169 9.78558 2.87996 9.8403 2.83804 9.89583C2.79444 9.95363 2.756 10.0156 2.72378 10.0804C2.69281 10.1428 2.66721 10.214 2.57535 10.4896L1.85562 12.6488C1.69461 13.1318 1.59097 13.4457 1.53628 13.6781C1.50647 13.8049 1.50104 13.8708 1.50015 13.8958C1.52121 13.9424 1.55814 13.9792 1.60464 14.0003C1.6294 13.9995 1.69496 13.9941 1.82242 13.9642C2.05483 13.9095 2.36849 13.8059 2.85171 13.6449L5.01089 12.9251C5.28667 12.8332 5.35767 12.8077 5.42007 12.7767C5.485 12.7445 5.54678 12.7061 5.60464 12.6624C5.66021 12.6205 5.71476 12.5689 5.92007 12.3636L11.6027 6.68099L8.81949 3.89779L3.13687 9.5804ZM12.2228 1.62239C11.895 1.46011 11.5095 1.45999 11.1818 1.62239C11.0374 1.69409 10.8767 1.84055 10.3107 2.40657L9.88003 2.83724L12.6632 5.62044L13.0939 5.18978C13.66 4.6237 13.8064 4.46307 13.8781 4.31868C14.0404 3.99089 14.0405 3.60544 13.8781 3.27767C13.8064 3.13328 13.66 2.97272 13.0939 2.40657C12.5275 1.84014 12.3673 1.694 12.2228 1.62239Z" fill="white"/>
      </svg>

    <!-- chevronBottom -->
    <svg v-if="typeImg == 'chevronBottom'" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.41 0.580078L6 5.17008L10.59 0.580078L12 2.00008L6 8.00008L0 2.00008L1.41 0.580078Z" fill="#FFFFFF"/>
    </svg>

    <!-- upload icon -->
    <svg
      v-if="typeImg == 'upload'"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 14.9861C11 15.5384 11.4477 15.9861 12 15.9861C12.5523 15.9861 13 15.5384 13 14.9861V7.82831L16.2428 11.0711L17.657 9.65685L12.0001 4L6.34326 9.65685L7.75748 11.0711L11 7.82854V14.9861Z"
        fill="white"
      />
      <path
        d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z"
        fill="white"
      />
    </svg>

    <!-- done icon -->
    <svg v-if="typeImg == 'done'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.99387 17.7546L0 10.7607L1.74847 9.01227L6.99387 14.2577L18.2515 3L20 4.74847L6.99387 17.7546Z" fill="white"/>
    </svg>

    <!-- cancel icon -->
    <svg v-if="typeImg == 'cancel'" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2777_18864)">
      <path d="M23.081 8.93909L17.0201 15L23.081 21.0609L21.0607 23.0812L14.9998 17.0203L8.93889 23.0812L6.91858 21.0609L12.9795 15L6.91858 8.93909L8.93889 6.91878L14.9998 12.9797L21.0607 6.91878L23.081 8.93909Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_2777_18864">
      <rect width="20" height="20" fill="white" transform="translate(0.857422 15) rotate(-45)"/>
      </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'ToolbarIcons',
  props: {
    typeImg: {
      type: String,
      default: 'plus'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pulsed: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    }

  }
}
</script>

<style lang="scss" scoped>
.wrapper-icon {
  @include flex-center;
  width: 46px;
  height: 42px;
  background: #00ABEC;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.6s;

  &:hover {
    background: #0080B0;
  }
  &:active {
    background: #006084;
  }

  &_disabled {
    pointer-events: none;
    background: rgb(0, 0, 0, 0.1) !important;
  }

  &_pulsed {
    animation: pulse 700ms ease-in 700ms infinite;
    animation-direction: alternate;
    svg {
      path {
        fill: #FFFFFF;
      }
    }
  }

  &.red {
    background: #C51B0E;

    &:hover {
      background: #A11208;
    }

    &:active {
      background: #7B0D05;
    }
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 5px rgb(27, 166, 218, 0.3);
  }
  30% {
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.3);
  }
}
</style>
